import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import hourglassIcon from '../assets/time glass sand.png';
import plant from '../assets/logo PNG Transparent/Logo-07.png';
import mainimgae from '../assets/_You’veStartedYourJourney.png';
import esscoBg from '../assets/essco-bg.png';
import Bloc from '../assets/Bloc.png';
import medalstar from '../assets/medal-star.png';
import Map from '../assets/Map.png';
import resultimgae from '../assets/result-imgae.png';
import songicon from '../assets/sound.png';
import newLogo from '../assets/new-Logo.png';
import Mirrorimage from '../assets/Mirror-image.png';
// Category icons
import icon1 from '../assets/Discover.png';
import icon2 from '../assets/Icon.png';
import icon3 from '../assets/Icon (1).png';
import icon4 from '../assets/Icon (2).png';
import icon5 from '../assets/Icon (3).png';
import icon6 from '../assets/Icon (4).png';
import icon7 from '../assets/Icon (5).png';
import Navbar from '../components/Navbar'
import Sidebar from '../components/Sidebar'
import DiSCResults from '../components/DiSCResults'
import Footer from './Footer';
import { toast } from 'react-toastify';
import api from "../sever/Api";
import { generateAIReport } from "../sever/Api";
import { notifyTestCompletion } from "../lib/testUtils";
import { ArrowRight } from 'lucide-react';
import { Card, CardHeader, CardTitle, CardDescription, CardContent } from "../components/card";
import { Button } from "../components/button";
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';

const valueWords = [
    "Integrity",
    "Honesty",
    "Respect",
    "Excellence",
    "Innovation",
    "Teamwork",
    "Accountability",
    "Compassion",
    "Growth",
    "Quality",
    "Trust",
    "Fairness",
    "Courage",
    "Dedication",
    "Authenticity",
    "Service",
    "Balance",
    "Creativity",
]

const feelingWords = [
    "Confident",
    "Anxious",
    "Motivated",
    "Frustrated",
    "Calm",
    "Excited",
    "Overwhelmed",
    "Focused",
    "Stressed",
    "Optimistic",
    "Uncertain",
    "Energized",
    "Peaceful",
    "Determined",
    "Worried",
    "Inspired",
    "Content",
    "Restless",
]

const reactionWords = [
    "Analyze",
    "Collaborate",
    "Delegate",
    "Adapt",
    "Communicate",
    "Plan",
    "Retreat",
    "Confront",
    "Research",
    "Seek help",
    "Take charge",
    "Listen",
    "Brainstorm",
    "Prioritize",
    "Reflect",
    "Act quickly",
    "Stay calm",
    "Problem-solve",
]

const questions = [
    {
        question: "Values -  What are the principles that matter most to your authentic self and guide your choices?",
        type: "wordbank",
        wordbank: valueWords,
        text: "What truly anchors you?"
    },
    {
        question: "Passions - What activities, interests, or topics fill you with energy or excitement?",
        type: "text",
        text: "When do you feel most alive?"
    },
    {
        question: "Goals - What dreams or achievements are you working toward or wish to accomplish in the future?",
        type: "text",
        text: "What are you moving toward?"
    },
    {
        question: "Environment - Think about where you feel most comfortable to be yourself—what kinds of settings or situations bring out the best in you?",
        type: "text",
        text: "Where do you thrive?"
    },
    {
        question: "Patterns - How would you describe the way you usually think, feel, or act across different situations? Are there habits or tendencies you notice?",
        type: "text",
        text: "How do you move through life?"
    },
    {
        question: "Responses - When faced with challenges or pressure, how do you usually respond or cope?",
        type: "text",
        text: "When things get tough, what do you do?"
    },
    {
        question: "Impact - What kind of positive influence do you want to have on others or the world around you?",
        type: "text",
        text: "What mark do you hope to leave?"
    },
]


const categoryIcons = [icon1, icon2, icon3, icon4, icon5, icon6, icon7]
const categoryTitleColors = [
    '#C136DB', // 1
    '#37C23C', // 2
    '#489CDF', // 3
    '#E8675B', // 4
    '#DFCE48', // 5
    '#6BD7CA', // 6
    '#4060DC', // 7
]

const SevenQuestion = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const { user } = useAuth();
    const [currentStep, setCurrentStep] = useState(0)
    const [selectedWords, setSelectedWords] = useState({})
    const [textAnswers, setTextAnswers] = useState({})
    const [answers, setAnswers] = useState({})
    const [showResults, setShowResults] = useState(false)
    const [showReport, setShowReport] = useState(false)
    const [results, setResults] = useState(null)
    const [previousResults, setPreviousResults] = useState([])
    const [showPreviousResults, setShowPreviousResults] = useState(false)
    const [loading, setLoading] = useState(false)
    const [saving, setSaving] = useState(false)
    const [aiReportLoading, setAiReportLoading] = useState(false)
    const [aiReportError, setAiReportError] = useState(null)
    const [aiReportText, setAiReportText] = useState("")
    const [showIntro, setShowIntro] = useState(true);
    const [showEncouragement, setShowEncouragement] = useState(false)
    const [encouragementText, setEncouragementText] = useState('')
    const [questionInsights, setQuestionInsights] = useState({})
    const [questionInsightsLoading, setQuestionInsightsLoading] = useState({})
    const currentQuestion = questions[currentStep]
    const totalSteps = questions.length
    const progress = ((currentStep + 1) / totalSteps) * 100


    const fetchPreviousResults = async () => {

        setPreviousResults([])
    }

    useEffect(() => {
        fetchPreviousResults()
    }, [])


    const borderColors = [
        '#c136db',
        '#37c23c',
        '#489cdf',
        '#e8675b',
        '#FFD580',
        '#A3E4A7',
    ];

    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const showResultsParam = params.get('showResults');
        if (showResultsParam === 'true') {
            setShowResults(true);
        }
    }, [location.search]);


    useEffect(() => {
        if (!showResults && !showIntro) {
            if (currentStep === 3) {
                setEncouragementText('Your goals sound great,\nkeep going!')
                setShowEncouragement(true)
                const t = setTimeout(() => setShowEncouragement(false), 3000)
                return () => clearTimeout(t)
            }
            if (currentStep === 5) {
                setEncouragementText("Good job!\nYou're almost finished!")
                setShowEncouragement(true)
                const t = setTimeout(() => setShowEncouragement(false), 3000)
                return () => clearTimeout(t)
            }
        }
    }, [currentStep, showResults, showIntro])

    const handleNext = () => {
        const hasWordSelection = currentQuestion.type === "wordbank" && (selectedWords[currentStep] || []).length > 0
        const hasTextAnswer = currentQuestion.type === "text" && (textAnswers[currentStep] || "").trim().length > 0

        if (!hasWordSelection && !hasTextAnswer) return

        const currentAnswer = {
            words: selectedWords[currentStep] || [],
            text: textAnswers[currentStep] || "",
            type: currentQuestion.type,
        }

        setAnswers((prev) => ({
            ...prev,
            [currentStep]: currentAnswer,
        }))

        if (currentStep < totalSteps - 1) {
            setCurrentStep((prev) => prev + 1)
        } else {
            const finalAnswers = {
                ...answers,
                [currentStep]: currentAnswer,
            }
            const calculatedResults = calculateResults(finalAnswers)
            setSaving(true)

            saveTestResult(finalAnswers, calculatedResults)
                .finally(() => setSaving(false))
        }
    }

    const calculateResults = (finalAnswers) => {
        const wordCount = Object.values(finalAnswers).reduce((sum, answer) => {
            return sum + (answer.words ? answer.words.length : 0)
        }, 0)

        const textCount = Object.values(finalAnswers).reduce((sum, answer) => {
            return sum + (answer.text ? answer.text.split(" ").length : 0)
        }, 0)

        let personalityType = "Balanced"
        if (wordCount > 15) {
            personalityType = "Expressive"
        } else if (textCount > 50) {
            personalityType = "Analytical"
        } else if (wordCount > 10) {
            personalityType = "Decisive"
        }

        return {
            score: {
                dominantType: personalityType,
                d: { percentage: Math.floor(Math.random() * 40) + 10 },
                i: { percentage: Math.floor(Math.random() * 40) + 10 },
                s: { percentage: Math.floor(Math.random() * 40) + 10 },
                c: { percentage: Math.floor(Math.random() * 40) + 10 },
            },
            takenAt: new Date().toISOString(),
            answers: finalAnswers,
        }
    }

    const buildDetailedAnswers = (finalAnswers) => {
        const detailed = []
        Object.entries(finalAnswers).forEach(([index, ans]) => {
            const q = questions[Number(index)]
            if (!q) return
            if (ans.type === 'wordbank') {
                (ans.words || []).forEach((word, idx) => {
                    detailed.push({
                        questionId: String(index),
                        questionText: q.question,
                        selectedOptionId: `${index}-w${idx}`,
                        selectedOptionText: word,
                    })
                })
            } else if (ans.type === 'text') {
                detailed.push({
                    questionId: String(index),
                    questionText: q.question,
                    selectedOptionId: `${index}-t1`,
                    selectedOptionText: ans.text,
                })
            }
        })
        return detailed
    }

    const saveTestResult = async (finalAnswers, calculatedResults) => {
        try {
            const detailedAnswers = buildDetailedAnswers(finalAnswers)
            const scores = calculatedResults.score
            const overallScore = 0
            const overallPercentage = Math.round((Object.keys(finalAnswers).length / questions.length) * 100)

            await api.post('/api/test-results', {
                testType: 'sevenquestion',
                answers: detailedAnswers,
                scores,
                overallScore,
                overallPercentage,
            })

            toast.success('Essence Echo results saved successfully!')
            setResults(calculatedResults)
            setShowResults(true)
            try {
                const testData = {
                    scores: { ...scores, personalityType: scores?.dominantType },
                    overallScore: overallPercentage,
                    overallPercentage,
                    testType: 'sevenquestion',
                    completed: true
                };
                notifyTestCompletion('sevenquestion', testData);
            } catch (e) { }
        } catch (error) {
            console.error('Error saving Essence Echo result:', error)
            toast.error(error.response?.data?.message || 'Failed to save test results')

            setResults(calculatedResults)
            setShowResults(true)
            try {
                const testData = {
                    scores: { ...calculatedResults.score, personalityType: calculatedResults.score?.dominantType },
                    overallScore: Math.round((Object.keys(finalAnswers).length / questions.length) * 100),
                    overallPercentage: Math.round((Object.keys(finalAnswers).length / questions.length) * 100),
                    testType: 'sevenquestion',
                    completed: true
                };
                notifyTestCompletion('sevenquestion', testData);
            } catch (e2) { }
        }
    }

    const fetchAIReport = async () => {
        try {
            setAiReportLoading(true);
            setAiReportError(null);
            const finalAns = results?.answers || answers;
            const detailedAnswers = buildDetailedAnswers(finalAns);
            const overallPercentage = Math.round((Object.keys(finalAns || {}).length / questions.length) * 100);
            const payload = {
                testType: 'sevenquestion',
                scores: results?.score || {},
                answers: detailedAnswers,
                overallScore: 0,
                overallPercentage
            };
            const { report } = await generateAIReport(payload);
            setAiReportText(report);
        } catch (err) {
            setAiReportError(err?.response?.data?.message || 'Failed to generate AI report');
        } finally {
            setAiReportLoading(false);
        }
    };

    const generateQuestionInsight = async (questionIndex) => {
        try {
            setQuestionInsightsLoading(prev => ({ ...prev, [questionIndex]: true }));

            const finalAns = results?.answers || answers;
            const question = questions[questionIndex];
            const answer = finalAns[questionIndex];

            if (!answer) return;


            const questionAnswers = [];
            if (answer.type === 'wordbank') {
                (answer.words || []).forEach((word, idx) => {
                    questionAnswers.push({
                        questionId: String(questionIndex),
                        questionText: question.question,
                        selectedOptionId: `${questionIndex}-w${idx}`,
                        selectedOptionText: word,
                    });
                });
            } else if (answer.type === 'text') {
                questionAnswers.push({
                    questionId: String(questionIndex),
                    questionText: question.question,
                    selectedOptionId: `${questionIndex}-t1`,
                    selectedOptionText: answer.text,
                });
            }

            const payload = {
                testType: 'sevenquestion_insight',
                questionIndex,
                questionText: question.question,
                questionType: question.type,
                answers: questionAnswers,
                scores: results?.score || {},
                overallScore: 0,
                overallPercentage: 100,
                insightType: 'concise',
                maxLines: 4
            };

            console.log('Sending payload for question insight:', payload);

            const { report } = await generateAIReport(payload);
            setQuestionInsights(prev => ({ ...prev, [questionIndex]: report }));
            // Return the generated report so callers (like PDF export) can use it immediately
            return report;
        } catch (err) {
            console.error('Error generating insight:', err);
            console.error('Error details:', err.response?.data || err.message);
            return null;
        } finally {
            setQuestionInsightsLoading(prev => ({ ...prev, [questionIndex]: false }));
        }
    };

    useEffect(() => {
        if (showReport && results && !aiReportText && !aiReportLoading) {
            fetchAIReport();
        }
    }, [showReport, results]);


    useEffect(() => {
        if (showResults && results && Object.keys(questionInsights).length === 0) {

            questions.forEach((_, index) => {
                setTimeout(() => {
                    generateQuestionInsight(index);
                }, index * 1000);
            });
        }
    }, [showResults, results]);

    const handleWordToggle = (word) => {
        setSelectedWords((prev) => {
            const currentWords = prev[currentStep] || []
            const isSelected = currentWords.includes(word)

            if (isSelected) {
                return {
                    ...prev,
                    [currentStep]: currentWords.filter((w) => w !== word),
                }
            } else if (currentWords.length < 5) {
                return {
                    ...prev,
                    [currentStep]: [...currentWords, word],
                }
            }
            return prev
        })
    }

    const resetTest = () => {
        setCurrentStep(0)
        setSelectedWords({})
        setTextAnswers({})
        setAnswers({})
        setShowResults(false)
        setResults(null)
    }
    const handleDownloadReflection = () => {
        try {
            const finalAns = results?.answers || answers || {};
            const header = 'Essence Echo Reflection\n\n';
            const dateLine = results?.takenAt ? `Date: ${new Date(results.takenAt).toLocaleString()}\n\n` : '';
            const aiSection = aiReportText ? `AI Synthesis:\n${aiReportText}\n\n` : '';
            const qa = Object.keys(finalAns).map((k) => {
                const idx = Number(k);
                const q = questions[idx];
                const ans = finalAns[idx] || {};
                const title = q?.question?.split(' - ')[0] || `Question ${idx + 1}`;
                const prompt = q?.question?.split(' - ')[1] || q?.question || '';
                const body = ans.type === 'wordbank' ? (ans.words || []).join(', ') : (ans.text || '');
                return `${title}\n${prompt}\n- ${body}\n`;
            }).join('\n');
            const content = `${header}${dateLine}${aiSection}${qa}`;
            const blob = new Blob([content], { type: 'text/plain;charset=utf-8' });
            const url = URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = 'Essence-Echo-Reflection.txt';
            document.body.appendChild(a);
            a.click();
            a.remove();
            URL.revokeObjectURL(url);
        } catch (e) { }
    }

    const handleDownloadPDF = async () => {
        try {
            const reportElement = document.querySelector('.congratulations-report');
            if (!reportElement) {
                toast.error('Report section not found');
                return;
            }

            toast.info('Generating PDF...');

            // Before capturing, ensure we've generated insights for all questions so the PDF can include them.
            // Use a local map (insightsForPdf) to collect generated insights synchronously
            // instead of relying only on React state (which updates asynchronously).
            let insightsForPdf = { ...(questionInsights || {}) };
            try {
                const missing = [];
                for (let qi = 0; qi < questions.length; qi++) {
                    if (!insightsForPdf.hasOwnProperty(qi) || !insightsForPdf[qi]) missing.push(qi);
                }
                if (missing.length > 0) {
                    toast.info(`Generating ${missing.length} insights for PDF... This may take a moment.`);
                    // Generate sequentially to avoid throttling
                    for (const idx of missing) {
                        try {
                            // generateQuestionInsight now returns the report string (or null on failure)
                            // eslint-disable-next-line no-await-in-loop
                            const report = await generateQuestionInsight(idx);
                            if (report) {
                                insightsForPdf[idx] = report;
                            } else if (questionInsights && questionInsights[idx]) {
                                // fallback to whatever is in state
                                insightsForPdf[idx] = questionInsights[idx];
                            }
                        } catch (err) {
                            console.warn('Failed to generate insight for', idx, err);
                        }
                    }
                }
            } catch (err) {
                console.warn('Error while generating missing insights before PDF:', err);
            }

            // Ensure page is at top and wait for fonts to be ready to avoid layout/fallback issues in the canvas
            try {
                // Scroll page to top to avoid html2canvas capturing a scrolled viewport slice
                if (typeof window !== 'undefined' && window.scrollTo) {
                    try { window.scrollTo(0, 0); } catch (e) { }
                }
                // Also ensure the report element is scrolled to top
                try { reportElement.scrollTop = 0; } catch (e) { }
            } catch (e) { }

            // Wait for fonts to be ready to avoid layout/fallback issues in the canvas
            if (document.fonts && document.fonts.ready) {
                try {
                    await document.fonts.ready;
                } catch (e) {
                    // ignore font loading errors
                }
            }

            const imgs = Array.from(reportElement.querySelectorAll('img'));
            await Promise.all(imgs.map((img) => {
                if (img.complete) return Promise.resolve();
                return new Promise((res) => {
                    img.onload = res;
                    img.onerror = res;
                });
            }));

            // Use the full scroll size so html2canvas captures the responsive layout regardless of viewport
            const targetWidth = Math.max(reportElement.scrollWidth, reportElement.clientWidth);
            // Add padding to ensure bottom sections are not clipped
            const targetHeight = Math.max(reportElement.scrollHeight, reportElement.clientHeight) + 1500;

            const canvas = await html2canvas(reportElement, {
                scale: Math.max(2, window.devicePixelRatio || 1),
                useCORS: true,
                allowTaint: true,
                backgroundColor: '#ffffff',
                logging: false,
                width: targetWidth,
                height: targetHeight,
                windowWidth: targetWidth,
                windowHeight: Math.max(targetHeight, document.documentElement.scrollHeight || targetHeight) + 2000,
                scrollX: 0,
                scrollY: 0,
                onclone: (clonedDoc) => {
                    try {
                        // Ensure the cloned document uses the same width/height as the report's full content
                        try {
                            clonedDoc.documentElement.style.width = targetWidth + 'px';
                            clonedDoc.body.style.width = targetWidth + 'px';
                            clonedDoc.documentElement.style.height = 'auto';
                            clonedDoc.body.style.height = 'auto';
                            clonedDoc.documentElement.style.overflow = 'visible';
                            clonedDoc.body.style.overflow = 'visible';
                        } catch (e) { }

                        // Ensure cloned window is scrolled to top
                        try {
                            if (clonedDoc.defaultView && clonedDoc.defaultView.scrollTo) clonedDoc.defaultView.scrollTo(0, 0);
                        } catch (e) { }

                        // Reduce risk of clipping: remove overflow/transform that can clip off-page content
                        try {
                            const allElems = clonedDoc.querySelectorAll('*');
                            allElems.forEach(el => {
                                const cs = clonedDoc.defaultView.getComputedStyle(el);
                                if (cs.overflow !== 'visible') el.style.overflow = 'visible';
                                if (cs.transform && cs.transform !== 'none') el.style.transform = 'none';
                                if (cs.position === 'fixed') el.style.position = 'absolute';
                                if (cs.maxHeight && cs.maxHeight !== 'none') el.style.maxHeight = 'none';
                            });
                        } catch (e) { }

                        try {
                       
                            const momentumHeading = Array.from(clonedDoc.querySelectorAll('h3'))
                                .find(h => h.textContent && h.textContent.trim().toLowerCase().includes('momentum reflection: carry it forward'));
                            if (momentumHeading) {
                                const momentumSection = momentumHeading.closest('div');
                                if (momentumSection) {
                                    momentumSection.style.display = 'block';
                                    momentumSection.style.overflow = 'visible';
                                }
                            }
                           
                            const finalCtaHeading = Array.from(clonedDoc.querySelectorAll('h3'))
                                .find(h => h.textContent && h.textContent.trim().toLowerCase().includes('your essence echo is safely saved'));
                            if (finalCtaHeading) {
                                const finalCtaSection = finalCtaHeading.closest('div');
                                if (finalCtaSection) {
                                    finalCtaSection.style.display = 'block';
                                    finalCtaSection.style.overflow = 'visible';
                                    // Add spacer after the Final CTA to guarantee it is within the rendered area
                                    try {
                                        const spacer = clonedDoc.createElement('div');
                                        spacer.style.height = '1200px';
                                        spacer.style.width = '1px';
                                        spacer.style.background = 'transparent';
                                        finalCtaSection.parentElement && finalCtaSection.parentElement.appendChild(spacer);
                                    } catch (_) {}
                                }
                            }
                        } catch (e) { }
                        const candidates = Array.from(clonedDoc.querySelectorAll('.bg-clip-text, .text-transparent'))
                            .filter(el => (el.textContent || '').trim().length > 0);

                        candidates.forEach((el, idx) => {
                            try {
                                const cs = clonedDoc.defaultView.getComputedStyle(el);
                                const bg = cs.backgroundImage || '';
                                if (!bg || bg === 'none') return; 

                                const rect = el.getBoundingClientRect();
                                const w = Math.max(Math.round(rect.width), 50);
                                const h = Math.max(Math.round(rect.height), Math.round(parseFloat(cs.fontSize || '16')));
                                const text = (el.textContent || '').trim();
                                if (!text) return;

                                const colorMatches = bg.match(/#(?:[0-9a-fA-F]{3,6})/g) || [];
                                const stops = colorMatches.length ? colorMatches : ['#B060D2', '#FD8E8F'];

                                const fontSize = cs.fontSize || '16px';
                                const fontFamily = cs.fontFamily || 'sans-serif';
                                const fontWeight = cs.fontWeight || '400';

                                const gradId = `svgGrad_${Date.now()}_${idx}`;

                                const stopsMarkup = stops.map((c, i) => `<stop offset='${Math.round((i / (stops.length - 1 || 1)) * 100)}%' stop-color='${c}'/>`).join('');

                                const svg = `<svg xmlns='http://www.w3.org/2000/svg' width='${w}' height='${h}' viewBox='0 0 ${w} ${h}'>` +
                                    `<defs><linearGradient id='${gradId}' x1='0%' y1='0%' x2='100%' y2='0%'>${stopsMarkup}</linearGradient></defs>` +
                                    `<text x='0' y='${Math.round(h * 0.75)}' font-family='${fontFamily}' font-size='${fontSize}' font-weight='${fontWeight}' fill='url(#${gradId})'>${text.replace(/</g, '&lt;').replace(/>/g, '&gt;')}</text>` +
                                    `</svg>`;

                                const wrapper = clonedDoc.createElement('div');
                                wrapper.style.display = 'inline-block';
                                wrapper.style.width = `${w}px`;
                                wrapper.style.height = `${h}px`;
                                wrapper.style.verticalAlign = 'middle';
                                wrapper.innerHTML = svg;

                                el.innerHTML = '';
                                el.appendChild(wrapper);
                                el.style.background = 'none';
                                el.style.webkitBackgroundClip = 'none';
                                el.style.backgroundClip = 'none';
                                el.style.color = 'transparent';
                                } catch (e) {
                                    console.warn('svg replace failed', e);
                                }

                        });

                        try {
                            const clonedRoot = clonedDoc.querySelector('.congratulations-report') || clonedDoc.body;
                            // Find the heading for the accordion
                            const heading = Array.from(clonedRoot.querySelectorAll('h3')).find(h => h.textContent && h.textContent.trim().toLowerCase().includes('what you shared and what it shows'));
                            let container = null;
                            if (heading) {
                               const section = heading.closest('div');
                                if (section) container = section.querySelector('.space-y-3');
                            }
                            if (!container) {
                                // fallback: first .space-y-3 in the cloned root
                                container = clonedRoot.querySelector('.space-y-3');
                            }

                            if (container) {
                                // Clear existing (this removes only the live accordion markup in the clone)
                                container.innerHTML = '';

                                // Build expanded panels for each question using our in-memory questionInsights
                                questions.forEach((q, idx) => {
                                    const panel = clonedDoc.createElement('div');
                                    panel.className = 'border rounded-lg overflow-hidden';

                                    // Header/title row
                                    const headerRow = clonedDoc.createElement('div');
                                    headerRow.className = 'w-full flex items-center justify-between p-6 bg-white';
                                    headerRow.style.display = 'flex';
                                    headerRow.style.alignItems = 'center';
                                    headerRow.style.gap = '12px';

                                    const left = clonedDoc.createElement('div');
                                    left.style.display = 'flex';
                                    left.style.alignItems = 'center';
                                    left.style.gap = '12px';

                                    // category icon (if available on the page it will load via src)
                                    const img = clonedDoc.createElement('img');
                                    try { img.src = (categoryIcons && categoryIcons[idx]) || ''; } catch (_) { img.src = ''; }
                                    img.style.width = '60px';
                                    img.style.height = 'auto';
                                    left.appendChild(img);

                                    const txtWrap = clonedDoc.createElement('div');
                                    const qTitle = clonedDoc.createElement('h2');
                                    qTitle.style.fontWeight = '700';
                                    qTitle.style.fontSize = '21px';
                                    qTitle.style.margin = '0';
                                    qTitle.textContent = q.question.split(' - ')[0] || `Question ${idx + 1}`;

                                    const qSub = clonedDoc.createElement('div');
                                    qSub.style.marginTop = '4px';
                                    qSub.style.fontSize = '14px';
                                    qSub.textContent = q.question.split(' - ')[1] || '';

                                    txtWrap.appendChild(qTitle);
                                    txtWrap.appendChild(qSub);
                                    left.appendChild(txtWrap);

                                    headerRow.appendChild(left);
                                    panel.appendChild(headerRow);

                                    // Content (insight)
                                    const content = clonedDoc.createElement('div');
                                    content.className = 'p-4 bg-white text-sm text-gray-700';

                                    const inner = clonedDoc.createElement('div');
                                    inner.className = 'border-t pt-4';

                                    const insightBox = clonedDoc.createElement('div');
                                    insightBox.style.background = 'linear-gradient(90deg,#F6F0FB, #FDEFF3)';
                                    insightBox.style.borderRadius = '8px';
                                    insightBox.style.padding = '12px';
                                    insightBox.style.border = '1px solid rgba(229, 213, 255, 0.6)';

                                    const insightText = clonedDoc.createElement('div');
                                    insightText.style.whiteSpace = 'pre-wrap';
                                        let insightContent = '';
                                        try {
                                            // Prefer the local insightsForPdf map collected above (most up-to-date)
                                            if (typeof insightsForPdf !== 'undefined' && insightsForPdf[idx]) insightContent = insightsForPdf[idx];
                                            else if (questionInsights && questionInsights[idx]) insightContent = questionInsights[idx];
                                            else if (results && results.answers && results.answers[idx]) {
                                                const a = results.answers[idx];
                                                insightContent = a.type === 'wordbank' ? (a.words || []).join(', ') : (a.text || '');
                                            } else {
                                                insightContent = 'No insight available.';
                                            }
                                        } catch (e) {
                                            insightContent = 'No insight available.';
                                        }
                                    insightText.textContent = insightContent;

                                    insightBox.appendChild(insightText);
                                    inner.appendChild(insightBox);
                                    content.appendChild(inner);
                                    panel.appendChild(content);

                                    container.appendChild(panel);
                                });
                            }
                        } catch (err) {
                            // Non-fatal: continue PDF generation even if we fail to inject insights
                            // (they may already be present for opened accordions)
                            // eslint-disable-next-line no-console
                            console.warn('Could not inject expanded question insights into cloned DOM:', err);
                        }
                        try {
                            const headings = Array.from(clonedDoc.querySelectorAll('h3, h2')).filter(h => h.textContent && h.textContent.trim().toLowerCase().includes('what you shared and what it shows'));
                            headings.forEach(h => {
                                const section = h.closest('.mt-50') || h.closest('.mt-30') || h.parentElement;
                                if (section) {
                                    section.style.marginTop = '150px';
                                    section.style.paddingTop = (section.style.paddingTop || '0px');
                                }
                            });
                        } catch (e) {
                            console.warn('failed to adjust section margin in onclone', e);
                        }

                        try {
                            const savedHeadings = Array.from(clonedDoc.querySelectorAll('h3, h2')).filter(h => h.textContent && h.textContent.trim().toLowerCase().includes('your essence echo is safely saved'));
                            savedHeadings.forEach(h => {
                                let section = h.closest('div') || h.parentElement;
                                let ancestor = h;
                                for (let i = 0; i < 6; i++) {
                                    if (!ancestor) break;
                                   try {
                                        const btn = ancestor.querySelector && ancestor.querySelector('button');
                                        if (btn && btn.textContent && btn.textContent.toLowerCase().includes('download my reflection')) {
                                            section = ancestor;
                                            break;
                                        }
                                    } catch (er) { }
                                    ancestor = ancestor.parentElement;
                                    if (ancestor && ancestor.tagName === 'BODY') break;
                                }

                                if (section) {
                                   section.style.marginTop = '100px';
                                   if (!section.style.paddingTop) section.style.paddingTop = '0px';
                                }
                            });
                        } catch (e) {
                            console.warn('failed to adjust final CTA margin in onclone', e);
                        }
                        try {
                            const allSpans = Array.from(clonedDoc.querySelectorAll('span'));
                            const keywordSpans = allSpans.filter(s => {
                                try {
                                    const cs = clonedDoc.defaultView.getComputedStyle(s);
                                    return (cs && (cs.height && cs.height.indexOf('30') !== -1)) || (s.className && s.className.includes('rounded-[30px]'));
                                } catch (e) {
                                    return false;
                                }
                            });

                            keywordSpans.forEach(el => {
                                try {
                                    el.style.display = 'flex';
                                    el.style.justifyContent = 'center';
                                    el.style.alignItems = 'flex-start';
                                    el.style.paddingTop = el.style.paddingTop || '4px';
                                    el.style.lineHeight = '1';
                                } catch (e) { }
                            });
                        } catch (e) {
                            console.warn('failed to nudge keyword chips in onclone', e);
                        }
                    } catch (e) {
                        console.warn('onclone error', e);
                    }
                }
            });

            // If the produced canvas is shorter than the targetHeight, html2canvas may have
            // clipped due to browser canvas size limits. In that case, fall back to segmented
            // capture: render vertical slices and add each slice as a PDF page.
            const pdf = new jsPDF('p', 'mm', 'a4');
            const pageWidth = pdf.internal.pageSize.getWidth();
            const pageHeight = pdf.internal.pageSize.getHeight();

            const createPdfFromCanvas = (cnv) => {
                const imgData = cnv.toDataURL('image/jpeg', 1.0);
                const imgProps = pdf.getImageProperties(imgData);
                const pdfImgWidth = pageWidth;
                const pdfImgHeight = (imgProps.height * pdfImgWidth) / imgProps.width;
                return { imgData, pdfImgHeight };
            };

            let usedFallback = false;
            try {
                if (canvas && canvas.height && canvas.height >= targetHeight - 10) {
                    // full-canvas capture succeeded
                    const { imgData, pdfImgHeight } = createPdfFromCanvas(canvas);
                    let position = 0;
                    pdf.addImage(imgData, 'JPEG', 0, position, pageWidth, pdfImgHeight);

                    let heightLeft = pdfImgHeight - pageHeight;
                    while (heightLeft > 0) {
                        position = heightLeft - pdfImgHeight;
                        pdf.addPage();
                        pdf.addImage(imgData, 'JPEG', 0, position, pageWidth, pdfImgHeight);
                        heightLeft -= pageHeight;
                    }
                } else {
                    // Canvas was clipped or missing parts — fallback to segmented capture
                    usedFallback = true;
                    const scale = Math.max(2, window.devicePixelRatio || 1);
                    const segmentHeight = Math.floor((window.innerHeight || 1000));

                    // Compute important section tops inside the report to avoid slicing them
                    const specialSelectors = [
                        // Momentum Reflection heading
                        () => Array.from(reportElement.querySelectorAll('h3, h2')).find(h => h.textContent && h.textContent.toLowerCase().includes('momentum reflection')),
                        // Final CTA heading
                        () => Array.from(reportElement.querySelectorAll('h3, h2')).find(h => h.textContent && h.textContent.toLowerCase().includes('your essence echo is safely saved')),
                    ];
                    const specialTops = [];
                    try {
                        const baseRect = reportElement.getBoundingClientRect();
                        specialSelectors.forEach(fn => {
                            try {
                                const el = fn();
                                if (el) {
                                    // compute offsetTop relative to reportElement
                                    const rect = el.getBoundingClientRect();
                                    const top = Math.max(0, Math.round(rect.top - baseRect.top + (reportElement.scrollTop || 0)));
                                    const bottom = top + Math.round(rect.height || 0);
                                    specialTops.push({ top, bottom });
                                }
                            } catch (e) { }
                        });
                    } catch (e) { }

                    let y = 0;
                    let first = true;
                    while (y < targetHeight) {
                        let thisHeight = Math.min(segmentHeight, targetHeight - y);

                        // If any special section would be split by this slice, move the slice start
                        // to the special section's top so it appears whole in this (or next) slice.
                        try {
                            for (const s of specialTops) {
                                if (s.top > y && s.top < y + thisHeight && s.bottom > y + thisHeight) {
                                    // section crosses the bottom boundary of this slice
                                    // start this slice at the section top instead
                                    y = s.top;
                                    thisHeight = Math.min(segmentHeight, targetHeight - y);
                                    break;
                                }
                            }
                        } catch (e) { }

                        // capture this slice
                        // eslint-disable-next-line no-await-in-loop
                        const partCanvas = await html2canvas(reportElement, {
                            scale,
                            useCORS: true,
                            allowTaint: true,
                            backgroundColor: '#ffffff',
                            logging: false,
                            width: targetWidth,
                            height: thisHeight,
                            x: 0,
                            y: y,
                            windowWidth: targetWidth,
                            windowHeight: targetHeight,
                            scrollX: 0,
                            scrollY: y,
                            onclone: (clonedDoc) => {
                                try {
                                    // Mirror same onclone adjustments for each slice
                                    clonedDoc.documentElement.style.width = targetWidth + 'px';
                                    clonedDoc.body.style.width = targetWidth + 'px';
                                    clonedDoc.documentElement.style.height = targetHeight + 'px';
                                    clonedDoc.body.style.height = targetHeight + 'px';
                                    clonedDoc.documentElement.style.overflow = 'visible';
                                    clonedDoc.body.style.overflow = 'visible';
                                    if (clonedDoc.defaultView && clonedDoc.defaultView.scrollTo) clonedDoc.defaultView.scrollTo(0, y);
                                } catch (e) { }
                            }
                        });

                        const { imgData, pdfImgHeight } = createPdfFromCanvas(partCanvas);
                        if (first) {
                            pdf.addImage(imgData, 'JPEG', 0, 0, pageWidth, pdfImgHeight);
                            first = false;
                        } else {
                            pdf.addPage();
                            pdf.addImage(imgData, 'JPEG', 0, 0, pageWidth, pdfImgHeight);
                        }

                        y += thisHeight;
                    }
                }
            } catch (err) {
                // If anything fails, attempt simple single-image fallback (best-effort)
                console.warn('PDF assembly fallback triggered', err);
                const imgData = canvas.toDataURL('image/jpeg', 1.0);
                const imgProps = pdf.getImageProperties(imgData);
                const pdfImgWidth = pageWidth;
                const pdfImgHeight = (imgProps.height * pdfImgWidth) / imgProps.width;
                pdf.addImage(imgData, 'JPEG', 0, 0, pageWidth, pdfImgHeight);
            }

            // Metadata
            pdf.setProperties({ title: 'Essence Echo Report', author: 'Essence Echo' });

            // Download
            pdf.save('Essence-Echo-Report.pdf');
            toast.success('PDF downloaded successfully!');
        } catch (error) {
            console.error('Error generating PDF:', error);
            toast.error('Failed to generate PDF. Try again or use the Print option in your browser.');
        }
    }
    const [openAccordion, setOpenAccordion] = useState(null)
    if (showIntro) {
        return (
            <div className="min-h-screen  bg-[linear-gradient(114.21deg,_rgba(243,234,255,0.3)_0.37%,_rgba(225,222,236,0.3)_10.91%,_rgba(216,214,251,0.3)_25.17%,_rgba(205,209,254,0.3)_62.19%,_rgba(254,236,255,0.3)_91.28%)] rounded-lg p-4" style={{
                backgroundImage: `url(${esscoBg})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat'
            }}>
                <img src={newLogo} className="w-64 h-full" style={{ position: 'relative', top: 30 }} />
                <div
                    className="min-h-screen flex flex-col items-center justify-center px-6"

                >

                    {/* Header */}
                    <div className="text-center max-w-6xl">
                        <h1 className=" font-semibold text-[48px] leading-[64px] text-center text-[#000000] "
                            style={{ fontFamily: 'Playfair Display, serif' }}>
                            Essence Echo:
                        </h1>
                        <p className=" font-semibold text-[48px] leading-[64px] text-[#7A81FF] mb-2"
                            style={{ fontFamily: 'Playfair Display, serif', fontStyle: 'italic' }}>
                            A Reflection of Who You Are
                        </p>
                        <div className="w-[90%] h-[2px] bg-[linear-gradient(90deg,_rgba(171,176,255,0.1)_12.45%,_rgba(114,121,238,0.5)_49.52%,_rgba(208,210,253,0.1)_95.19%)] shadow-[0_2px_4px_rgba(0,0,0,0.05)] rounded-[10px] " style={{ margin: '0 auto' }}></div>

                        <div className=" mt-5 mb-8">
                            <p className=" font-semibold text-[24px] leading-[32px] text-center text-[#000000]"
                                style={{ fontFamily: 'Playfair Display, serif' }}>Essence Echo is not a typical personality quiz.</p>
                            <p className="mt-5 font-medium text-[16px] leading-[19px] text-center text-[#9E9FA0]" style={{ width: '70%', margin: '0 auto' }}> It’s a guided reflection that invites you to look beneath the surface
                                and explore what truly drives you and who you are made of.</p>

                        </div>

                        {/* Info boxes */}
                        <div className="bg-[linear-gradient(95.58deg,_#F3F3FE_0.28%,_#F9F3FF_99.72%)] shadow-[0_2px_7px_rgba(0,0,0,0.07)] rounded-[24px] p-4">

                            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-10 text-left">
                                <div className="bg-white p-5 rounded-xl shadow-md border border-gray-100">
                                    <h3 className=" font-medium text-[24px] leading-[24px] text-center text-[#000000] mb-2" style={{ fontFamily: 'Playfair Display, serif', lineHeight: '28px' }}>
                                        Instead of choosing from preset answers, you  <span className="text-[#7279EE] font-medium">will write your own.</span>
                                    </h3>
                                    <p className="mt-5 font-medium text-[14px] leading-[17px] text-center text-[#9E9FA0]">
                                        Each question helps uncover the layers that shape who you are: your values, passions, goals, and patterns.
                                    </p>
                                </div>
                                <div className="bg-white p-5 rounded-xl shadow-md border border-gray-100">
                                    <h3 className="not-italic font-medium text-[24px] leading-[21px] text-center text-[#000000] mb-2" style={{ fontFamily: 'Playfair Display, serif', lineHeight: '28px' }}>
                                        What you write <span className="text-[#7279EE] font-medium">today</span>  reflects who you are at this <span className="text-[#7279EE] font-medium">moment</span>.
                                    </h3>
                                    <p className=" font-medium text-[14px] leading-[17px] text-center text-[#9E9FA0]">
                                        As you move through the other assessments later down the heart work compass and your clarity deepens, you will return here to see how your essence has evolved.
                                    </p>
                                </div>
                            </div>
                            <div className="bg-[#fff] border border-purple-100 text-purple-700 text-sm p-4 rounded-lg  inline-block" style={{ width: '60%' }}
                            >
                                <p className="not-italic font-semibold text-[18px] leading-[24px] text-center bg-[linear-gradient(90deg,_#B262D0_0%,_#F98C92_100%)] bg-clip-text text-transparent" style={{ fontFamily: 'Playfair Display, serif', margin: '0 auto' }}>
                                    “This is your personal echo, a mirror that grows with you and reveals more each time you listen”
                                </p>

                            </div>
                        </div>
                        <p className="text-gray-500 mb-4 mt-5">
                            <span className="text-[#7279EE] font-medium">{totalSteps} questions • </span> Self-reflection journey
                        </p>

                        {/* Question categories */}
                        <div className="flex flex-wrap justify-center gap-3 mb-10 mt-5">
                            {[
                                { name: "Values", color: "bg-[linear-gradient(93.82deg,_#FFFAFF_0.85%,_#FEF5FF_100%)] shadow-[0_2px_7px_rgba(0,0,0,0.07)] text-[#C136DB]", icon: icon1 },
                                { name: "Passions", color: "rounded-2xl bg-[linear-gradient(90deg,_#FCFFFC_0%,_#F9FFF9_100%)] shadow-[0_2px_7px_rgba(0,0,0,0.07)] text-[#37C23C]", icon: icon2 },
                                { name: "Goals", color: "rounded-2xl bg-[linear-gradient(90deg,_#F6FCFF_0%,_#F2FAFE_100%)] shadow-[0_2px_7px_rgba(0,0,0,0.07)] text-[#489CDF]", icon: icon3 },
                                { name: "Environment", color: "bg-[linear-gradient(113.76deg,rgba(255,251,250,0.6)_0.59%,rgba(255,247,246,0.6)_99.41%)] shadow-[0px_2px_7px_rgba(0,0,0,0.07)] rounded-[16px] text-[#E8675B]", icon: icon4 },
                                { name: "Patterns", color: "rounded-2xl bg-[linear-gradient(90deg,_#FFFBFB_0%,_#FFF7F6_100%)] shadow-[0_2px_7px_rgba(0,0,0,0.07)] text-[#DFCE48]", icon: icon5 },
                                { name: "Responses", color: "rounded-2xl bg-[linear-gradient(90deg,_#FBFFFD_0%,_#F6FFFD_100%)] shadow-[0_2px_7px_rgba(0,0,0,0.07)] text-[#6BD7CA]", icon: icon6 },
                                { name: "Impact", color: "rounded-2xl bg-[linear-gradient(90deg,_#FBFFFD_0%,_#F6FFFD_100%)] shadow-[0_2px_7px_rgba(0,0,0,0.07)] text-[#4060DC]", icon: icon7 },
                            ].map((item, i) => (
                                <span
                                    key={i}
                                    className={`${item.color} px-4 py-4  text-sm font-medium flex items-center  gap-3`} style={{ flexDirection: 'column', width: 150, borderRadius: 10 }}
                                >
                                    <img src={item.icon} alt={item.name} className="w-10 h-10" />
                                    {item.name}
                                </span>
                            ))}
                        </div>

                        {/* Total steps */}


                        {/* Start Button */}
                        <button
                            onClick={() => setShowIntro(false)}
                            className="mt-3 px-8 py-4 rounded-lg bg-[#7A81FF] shadow-[inset_-4px_-4px_14px_rgba(255,255,255,0.25),_inset_4px_4px_14px_rgba(0,0,0,0.25)" style={{ color: "#fff", fontSize: '18px', width: '40%' }}
                        >
                            Start Reflection
                        </button>
                    </div>
                </div>
            </div>
        );
    }
    if (showResults && results) {
        if (showReport) {
            const detailed = results.answers || {}
            return (
                <div className="min-h-screen w-full overflow-x-hidden bg-gradient-to-br from-[#EFF6FF] via-white to-[#F9FAFB] relative">
                    <div className="fixed top-0 left-0 h-screen w-64 bg-white shadow-md z-10">
                        <Sidebar />
                    </div>
                    <div className="ml-64">
                        <Navbar toggleSidebar={() => { }} />

                        <div className="w-full max-w-5xl mx-auto p-6">
                            <div className="rounded-lg border text-card-foreground shadow-sm bg-[#ffffff] p-6">
                                <h2 className="text-2xl font-bold text-gray-900 mb-2">Detailed Essence Echo Report</h2>
                                <p className="text-gray-600 mb-6">Your selections and reflections for each question.</p>

                                <div className="rounded-md border p-4 mb-6">
                                    <div className="font-semibold mb-2">We are collecting your results</div>
                                    {aiReportLoading && (
                                        <div className="flex items-center text-gray-600">
                                            <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-blue-600 mr-2"></div>
                                            Generating your report...
                                        </div>
                                    )}
                                    {aiReportError && (
                                        <div className="text-red-600 text-sm mb-2">{aiReportError}</div>
                                    )}
                                    {!aiReportLoading && aiReportText && (
                                        <div className="prose max-w-none whitespace-pre-wrap text-gray-800 text-sm">{aiReportText}</div>
                                    )}
                                    {!aiReportLoading && !aiReportText && (
                                        <button onClick={fetchAIReport} className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition">Generate Report</button>
                                    )}
                                </div>

                                <div className="space-y-6">
                                    {questions.map((q, idx) => {
                                        const ans = detailed[idx] || {}
                                        const words = ans.words || []
                                        const text = ans.text || ''
                                        return (
                                            <div key={idx} className="rounded-md border p-4">
                                                <div className="text-sm text-gray-500 mb-1">Question {idx + 1}</div>
                                                <div className="font-semibold mb-3">{q.question}</div>
                                                {q.type === 'wordbank' && (
                                                    <div className="flex flex-wrap gap-2 mb-3">
                                                        {words.length > 0 ? words.map((w, widx) => (
                                                            <span key={widx} className="px-2 py-1 rounded-full text-xs bg-purple-100 text-purple-700 border border-purple-200">{w}</span>
                                                        )) : <span className="text-xs text-gray-500">No words selected</span>}
                                                    </div>
                                                )}
                                                {q.type === 'text' && (
                                                    <div className="text-sm text-gray-700 whitespace-pre-wrap">{text || 'No response provided'}</div>
                                                )}
                                            </div>
                                        )
                                    })}
                                </div>

                                <div className="mt-8 flex gap-4">
                                    <button
                                        onClick={() => setShowReport(false)}
                                        className="px-6 py-2 rounded border border-gray-300 text-gray-700 bg-white hover:bg-gray-100"
                                    >
                                        Back to Results
                                    </button>
                                    <button
                                        onClick={resetTest}
                                        className="px-6 py-2 rounded bg-purple-600 text-white hover:bg-purple-700"
                                    >
                                        Retake Test
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )
        }
        const { dominantType, d, i, s, c } = results.score || {}
        return (
            <div className="min-h-screen w-full overflow-x-hidden relative p-10 bg-[linear-gradient(114.21deg,_rgba(243,234,255,0.3)_0.37%,_rgba(225,222,236,0.3)_10.91%,_rgba(216,214,251,0.3)_25.17%,_rgba(205,209,254,0.3)_62.19%,_rgba(254,236,255,0.3)_91.28%)] congratulations-report" style={{
                backgroundImage: `url(${esscoBg})`,
                backgroundSize: 'contain',
                backgroundPosition: 'top',
                backgroundRepeat: 'no-repeat'
            }}>
                <img src={newLogo} className="w-64 h-full" style={{ position: 'relative', top: 30, left: 10 }} />
                <div >
                    <div className="w-full max-w-6xl mx-auto p-6">
                        <h2 className="text-4xl font-bold text-gray-800 mb-6 text-center" style={{ fontFamily: 'Playfair Display, serif' }}>Congratulations</h2>

                        <img src={mainimgae} alt="resultimgae" className="mx-auto mb-6" style={{ maxWidth: '600px' }} />
                        <p className=' font-normal text-[16px] leading-[19px] text-center text-[#151417]' style={{ fontFamily: 'Lato, sans-serif' }}>
                            Congratulations {(() => {
                                try {
                                    if (user?.firstName) return String(user.firstName).trim();
                                    if (user?.name && typeof user.name === 'string') {
                                        const firstWord = user.name.trim().split(/\s+/)[0];
                                        return firstWord || 'User';
                                    }
                                    return 'User';
                                } catch (_) {
                                    return 'User';
                                }
                            })()}!
                        </p>
                        <p className=' font-normal text-[16px] leading-[19px] text-center text-[#151417]' style={{ fontFamily: 'Lato, sans-serif' }}> You’ve taken the first step in The Hard Work Is The Hard Work Method.</p>
                        <img src={resultimgae} alt="resultimgae" className="mx-auto mb-6" style={{ maxWidth: '400px' }} />
                        <p className='font-semibold text-[16px] leading-[19px] text-center text-[#7A81FF] mb-5'>The road ahead will unfold soon. For now, reflect on where you stand today.</p>
                        <img src={Map} alt="resultimgae" className="mx-auto mb-6" />
                        <div className="grid grid-cols-2 sm:grid-cols-2 gap-4">
                            <div className="rounded-lg border text-card-foreground shadow-sm bg-[#ffffff] p-6 text-center justify-center flex items-center flex-col">
                                <h2 className='text-center text-[24px] leading-[32px] font-medium bg-[linear-gradient(90deg,_#B060D2_0%,_#FD8E8F_100%)] bg-clip-text text-transparent' style={{ fontFamily: 'Playfair Display, serif' }}>This moment matters.</h2>
                                <p style={{ fontSize: '16px' }}>You took time to slow down, reflect, and look inward. </p>
                            </div>
                            <div className="rounded-lg border text-card-foreground shadow-sm bg-[#ffffff] p-6 text-center justify-center flex items-center flex-col">
                                <h2 className='text-center text-[24px] leading-[32px] font-medium bg-[linear-gradient(90deg,_#B060D2_0%,_#FD8E8F_100%)] bg-clip-text text-transparent' style={{ fontFamily: 'Playfair Display, serif' }}>Every insight you uncovered today lays the foundation for your journey.</h2>
                                <p style={{ fontSize: '16px' }}>It leads you toward greater clarity, confidence, and connection. </p>
                            </div>
                            <div className="rounded-lg border text-card-foreground shadow-sm bg-[#ffffff] p-6 text-center justify-center flex items-center flex-col">
                                <h2 className='text-center text-[24px] leading-[32px] font-medium bg-[linear-gradient(90deg,_#B060D2_0%,_#FD8E8F_100%)] bg-clip-text text-transparent' style={{ fontFamily: 'Playfair Display, serif' }}>The road ahead holds 11 more stages  of discovery.</h2>
                                <p style={{ fontSize: '16px' }}>Each one is designed to draw out all your potential. </p>
                            </div>
                            <div className="rounded-lg border text-card-foreground shadow-sm bg-[#ffffff] p-6 text-center justify-center flex items-center flex-col">
                                <h2 className='text-center text-[24px] leading-[32px] font-medium bg-[linear-gradient(90deg,_#B060D2_0%,_#FD8E8F_100%)] bg-clip-text text-transparent' style={{ fontFamily: 'Playfair Display, serif' }}>Each one builds on what you began here.</h2>
                                <p style={{ fontSize: '16px' }}>By the end, you’ll see how your answers today have evolved from what you unveil deep within.</p>
                            </div>
                        </div>

                        <div className="mt-8 bg-[rgba(255,255,255,0.6)] border border-black rounded-[32px] p-6 shadow-lg">
                            <div className="text-center mb-6">
                                <div className="flex items-center justify-center gap-3 mb-2">
                                    <div  ><svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path opacity="0.4" d="M30.1048 12.962C26.8323 7.81947 22.044 4.85864 17.0007 4.85864C14.479 4.85864 12.0282 5.59531 9.78982 6.96948C7.55148 8.35781 5.53982 10.3836 3.89648 12.962C2.47982 15.1861 2.47982 18.7986 3.89648 21.0228C7.16898 26.1795 11.9573 29.1261 17.0007 29.1261C19.5223 29.1261 21.9732 28.3895 24.2115 27.0153C26.4498 25.627 28.4615 23.6011 30.1048 21.0228C31.5215 18.8128 31.5215 15.1861 30.1048 12.962ZM17.0007 22.7228C13.8273 22.7228 11.2773 20.1586 11.2773 16.9995C11.2773 13.8403 13.8273 11.2761 17.0007 11.2761C20.174 11.2761 22.724 13.8403 22.724 16.9995C22.724 20.1586 20.174 22.7228 17.0007 22.7228Z" fill="#7B82FF" />
                                        <path d="M17.0004 12.9492C14.7762 12.9492 12.9629 14.7626 12.9629 17.0009C12.9629 19.2251 14.7762 21.0384 17.0004 21.0384C19.2246 21.0384 21.0521 19.2251 21.0521 17.0009C21.0521 14.7767 19.2246 12.9492 17.0004 12.9492Z" fill="#7B82FF" />
                                    </svg>
                                    </div>
                                    <h3 className=" font-semibold text-[36px] leading-[48px] text-black" style={{ fontFamily: 'Playfair Display, serif' }}>Your reflection at a glance</h3>
                                </div>
                                <p className="font-normal text-[16px] leading-[19px] text-center text-[#9E9FA0] max-w-2xl mx-auto">Here's a snapshot of what your reflections reveal. These keywords capture the energy and focus of your responses — the essence of who you are right now.</p>
                                <div className="text-xs text-indigo-500 mt-2">
                                    {(() => {
                                        const displayName = (() => {
                                            try {
                                                if (user?.firstName) return String(user.firstName).trim();
                                                if (user?.name && typeof user.name === 'string') {
                                                    const firstWord = user.name.trim().split(/\s+/)[0];
                                                    return firstWord || 'User';
                                                }
                                                return 'User';
                                            } catch (_) {
                                                return 'User';
                                            }
                                        })();

                                        const dateStr = results?.takenAt ? new Date(results.takenAt).toLocaleDateString('en-US', {
                                            month: 'long',
                                            day: 'numeric',
                                            year: 'numeric'
                                        }) : '';

                                        return dateStr ? `${displayName}, ${dateStr}` : '';
                                    })()}
                                </div>
                            </div>
                            {(() => {
                                const finalAns = results?.answers || {};
                                const allWords = Object.values(finalAns).flatMap(a => (a.words || []));
                                const uniq = Array.from(new Set(allWords));
                                const keywords = uniq.slice(0, 8);
                                return (
                                    <div className="mt-6 grid grid-cols-1 md:grid-cols-2 gap-6">
                                        <div className="bg-white rounded-xl p-6 shadow-sm">
                                            <h4 className="font-bold text-[24px] leading-[29px] text-black mb-3">Your Essence Keywords</h4>
                                            <div className="flex flex-wrap gap-2 items-center">
                                                {keywords.length > 0 ? (
                                                    keywords.map((k, index) => (
                                                        <span
                                                            key={k}
                                                            className={`flex items-center justify-center px-3 h-[30px] bg-[linear-gradient(90.92deg,rgba(248,242,254,0.4)_1.23%,rgba(243,232,255,0.4)_98.77%)] border rounded-[30px] text-[16px] text-[#4b4545] text-center`}
                                                            style={{ borderColor: borderColors[index % borderColors.length] }}
                                                        >
                                                            <p style={{position:'relative', top:'-4px'}}>{k}</p>
                                                        </span>
                                                    ))
                                                ) : (
                                                    <div className="text-sm text-gray-500">No keywords available</div>
                                                )}
                                            </div>
                                        </div>
                                        <div className="bg-white rounded-xl p-6 shadow-sm">
                                            <h4 className="font-bold text-[24px] leading-[29px] text-black mb-3">A Summary of Essence</h4>
                                            <div className="font-medium text-[18px] leading-[22px] text-[#151417]" style={{ fontFamily: 'Lato, sans-serif' }}>
                                                {aiReportText ? (
                                                    <div className="whitespace-pre-wrap">{aiReportText}</div>
                                                ) : (
                                                    <div className='font-medium text-[18px] leading-[22px] text-black'>
                                                        Your reflections reveal a person who values authenticity, growth, and purpose. You think deeply, act intentionally, and move through life with a desire to align what you do with who you are. This is your starting point — the first echo of your true self.
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                )
                            })()}
                        </div>
                        {/* New accordion: What you shared and what it shows */}
                        <div className="mt-8">
                            <div className="mt-20">
                                <div className="text-center mb-6">
                                    <div className="flex items-center justify-center gap-3 mb-2">
                                        <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path opacity="0.4" d="M15.2286 3.47136C16.2061 2.63552 17.8069 2.63552 18.7986 3.47136L21.0369 5.39802C21.4619 5.76636 22.2553 6.06386 22.8219 6.06386H25.2303C26.7319 6.06386 27.9644 7.29636 27.9644 8.79802V11.2064C27.9644 11.7589 28.2619 12.5664 28.6303 12.9914L30.5569 15.2297C31.3928 16.2072 31.3928 17.808 30.5569 18.7997L28.6303 21.038C28.2619 21.463 27.9644 22.2564 27.9644 22.823V25.2314C27.9644 26.733 26.7319 27.9655 25.2303 27.9655H22.8219C22.2694 27.9655 21.4619 28.263 21.0369 28.6314L18.7986 30.558C17.8211 31.3939 16.2203 31.3939 15.2286 30.558L12.9903 28.6314C12.5653 28.263 11.7719 27.9655 11.2053 27.9655H8.75443C7.25276 27.9655 6.02026 26.733 6.02026 25.2314V22.8089C6.02026 22.2564 5.72276 21.463 5.36859 21.038L3.45609 18.7855C2.63443 17.808 2.63443 16.2214 3.45609 15.2439L5.36859 12.9914C5.72276 12.5664 6.02026 11.773 6.02026 11.2205V8.78386C6.02026 7.28219 7.25276 6.04969 8.75443 6.04969H11.2053C11.7578 6.04969 12.5653 5.75219 12.9903 5.38386L15.2286 3.47136Z" fill="#7B82FF" />
                                            <path d="M15.2861 21.4898C15.0028 21.4898 14.7336 21.3765 14.5353 21.1782L11.107 17.7498C10.6961 17.339 10.6961 16.659 11.107 16.2482C11.5178 15.8373 12.1978 15.8373 12.6086 16.2482L15.2861 18.9257L21.3778 12.834C21.7886 12.4232 22.4686 12.4232 22.8795 12.834C23.2903 13.2448 23.2903 13.9248 22.8795 14.3357L16.037 21.1782C15.8386 21.3765 15.5695 21.4898 15.2861 21.4898Z" fill="#7B82FF" />
                                        </svg>

                                        <h3 className="font-semibold text-[36px] leading-[48px] text-black" style={{ fontFamily: 'Playfair Display, serif' }}>What you shared and what it shows</h3>
                                    </div>
                                    <p className="text-sm text-black-500 mt-3" style={{ width: '50%', margin: '0 auto' }}>Every question you answered holds a piece of your story. Below are your reflections and the insights they reveal about your current mindset, patterns, and priorities.</p>


                                </div>

                                <div className="space-y-3">
                                    {questions.map((q, idx) => {
                                        const ans = (results?.answers && results.answers[idx]) || answers[idx] || {}
                                        const summary = ans.type === 'wordbank' ? (ans.words || []).join(', ') : (ans.text || '')
                                        const isOpen = openAccordion === idx
                                        return (
                                            <div key={idx} className="border rounded-lg overflow-hidden">
                                                <button type="button" onClick={() => {
                                                    if (!isOpen) {
                                                        // Generate insight when opening accordion
                                                        if (!questionInsights[idx] && !questionInsightsLoading[idx]) {
                                                            generateQuestionInsight(idx);
                                                        }
                                                    }
                                                    setOpenAccordion(isOpen ? null : idx);
                                                }} className="w-full flex items-center justify-between p-6 bg-white">
                                                    <div className="flex items-center  gap-3">

                                                        <img src={categoryIcons[idx]} alt={q.question.split(' - ')[0]} style={{ width: '60px' }} />
                                                        <div>
                                                            <h2 className="font-bold text-[21px] leading-[29px] text-start" style={{ color: categoryTitleColors[idx], fontFamily: 'Lato, sans-serif' }}>{q.question.split(' - ')[0]}</h2>
                                                            <div className="font-medium text-[16px] leading-[22px] text-[#151417] mt-1" style={{ fontFamily: 'Lato, sans-serif' }}>{q.question.split(' - ')[1]}</div>
                                                        </div>
                                                    </div>
                                                    <div className="text-sm text-gray-400 transform transition-transform duration-200" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', transform: isOpen ? 'rotate(180deg)' : 'rotate(0deg)' }}>
                                                        <svg width="18" height="11" viewBox="0 0 22 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path d="M1 1.5L11 9.5L21 1.5" stroke="#7B82FF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                                        </svg>
                                                    </div>
                                                </button>
                                                {isOpen && (
                                                    <div className="p-4 bg-[#fff] text-sm text-gray-700">
                                                
                                                        <div className="border-t pt-4">


                                                            {questionInsightsLoading[idx] && (
                                                                <div className="flex items-center text-gray-600 py-2">
                                                                    <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-[#7A81FF] mr-2"></div>
                                                                    Generating insight...
                                                                </div>
                                                            )}

                                                            {questionInsights[idx] && (
                                                                <div className="bg-gradient-to-r from-purple-50 to-pink-50 rounded-lg p-4 border border-purple-100">
                                                                    <div className="text-gray-700 text-sm leading-relaxed whitespace-pre-wrap">
                                                                        {questionInsights[idx]}
                                                                    </div>
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        )
                                    })}
                                </div>
                            </div>
                        </div>
                        {/* Mirror of your Echo */}
                        <div className="mt-8 rounded-2xl bg-[#fbf7ff] p-6 md:p-8 shadow-lg">
                            <div className="mb-6 flex items-center gap-2 justify-center">
                                <span className="text-purple-500"><svg width="35" height="34" viewBox="0 0 35 34" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M10.6933 4.0299C10.5893 3.53881 10.1558 3.1875 9.65385 3.1875C9.15187 3.1875 8.71838 3.53881 8.61439 4.0299C8.28538 5.58374 7.83485 6.62973 7.21307 7.37568C6.60466 8.10559 5.75504 8.64023 4.44868 9.02658C3.99726 9.16008 3.6875 9.57471 3.6875 10.0455C3.6875 10.5162 3.99726 10.9308 4.44868 11.0643C5.70397 11.4356 6.547 11.9389 7.16445 12.6578C7.79304 13.3896 8.27154 14.4418 8.61439 16.061C8.71838 16.5521 9.15187 16.9034 9.65385 16.9034C10.1558 16.9034 10.5893 16.5521 10.6933 16.061C11.0362 14.4418 11.5146 13.3893 12.1432 12.6575C12.7605 11.9386 13.6035 11.4353 14.8587 11.0644C15.3103 10.931 15.6202 10.5163 15.6202 10.0455C15.6202 9.5746 15.3103 9.15991 14.8587 9.0265C13.6035 8.65563 12.7605 8.15231 12.1432 7.43345C11.5146 6.70157 11.0362 5.64916 10.6933 4.0299Z" fill="url(#paint0_linear_117_1835)" />
                                    <path d="M22.4558 8.63652C22.3404 8.15968 21.9136 7.82381 21.423 7.82386C20.9324 7.82391 20.5056 8.15986 20.3903 8.63673C19.6057 11.8827 18.773 13.841 17.5965 15.2064C16.4348 16.5546 14.8386 17.439 12.256 18.3116C11.8242 18.4575 11.5336 18.8625 11.5337 19.3183C11.5337 19.7741 11.8245 20.1791 12.2563 20.3249C14.9534 21.2354 16.5699 22.1973 17.7121 23.5723C18.8725 24.9692 19.6426 26.9088 20.3904 29.9998C20.5057 30.4767 20.9326 30.8126 21.4232 30.8125C21.9138 30.8125 22.3406 30.4765 22.4558 29.9996C23.2404 26.7536 24.0732 24.7953 25.2497 23.43C26.4114 22.0817 28.0076 21.1974 30.5901 20.3248C31.0219 20.1789 31.3126 19.7738 31.3125 19.318C31.3124 18.8623 31.0217 18.4573 30.5899 18.3115C27.8882 17.3994 26.2731 16.4407 25.1326 15.0681C23.9738 13.6735 23.2054 11.7351 22.4558 8.63652Z" fill="url(#paint1_linear_117_1835)" />
                                    <defs>
                                        <linearGradient id="paint0_linear_117_1835" x1="27.5" y1="21" x2="6.5" y2="6" gradientUnits="userSpaceOnUse">
                                            <stop offset="0.439495" stop-color="#7B82FF" />
                                            <stop offset="0.683024" stop-color="#777CD5" stop-opacity="0.4" />
                                        </linearGradient>
                                        <linearGradient id="paint1_linear_117_1835" x1="27.5" y1="21" x2="6.5" y2="6" gradientUnits="userSpaceOnUse">
                                            <stop offset="0.439495" stop-color="#7B82FF" />
                                            <stop offset="0.683024" stop-color="#777CD5" stop-opacity="0.4" />
                                        </linearGradient>
                                    </defs>
                                </svg>
                                </span>
                                <h3 className="text-4xl font-bold" style={{ fontFamily: 'Playfair Display, serif' }}>Mirror of your Echo</h3>
                            </div>
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 items-center"
                                style={{
                                    backgroundImage: `url(${esscoBg})`,
                                    backgroundColor: '#F9F3FF',
                                    backgroundSize: 'cover',
                                    backgroundPosition: 'center',
                                    backgroundRepeat: 'no-repeat',
                                    borderRadius: '10px'
                                }}>
                                <div className="rounded-2xl overflow-hidden bg-white shadow-sm">
                                    <img src={Mirrorimage} alt="Mirror of your Echo wheel" className="w-full h-full object-cover" />
                                </div>
                                <div className="flex justify-center">
                                    <div className="bg-white rounded-2xl shadow-md p-6 max-w-md">
                                        <div className="text-center">
                                            <h2 className='text-center text-[24px] leading-[32px] font-medium bg-[linear-gradient(90deg,_#B060D2_0%,_#FD8E8F_100%)] bg-clip-text text-transparent mb-5' style={{ fontFamily: 'Playfair Display, serif' }}>Your reflections form a living
                                                pattern, an authentic picture of who
                                                you are in this present moment.</h2>
                                            <div className="text-xs text-gray-500">
                                                You’ll revisit this wheel as your journey continues to see
                                                how your essence evolves and expands.
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Momentum Reflection: Carry It Forward */}
                        <div className="mt-8 rounded-2xl  p-10 "
                            style={{
                                backgroundImage: `url(${Bloc})`,
                                backgroundSize: 'cover',
                                backgroundPosition: 'top',
                                backgroundRepeat: 'no-repeat',
                                borderRadius: '15px'
                            }}>
                            <div className="flex items-center justify-center gap-3 mb-2">
                                <div className="w-6 h-6 rounded-md bg-indigo-500/90 flex items-center justify-center text-white text-sm">✦</div>
                                <h3 className="text-4xl font-bold text-gray-900" style={{ fontFamily: 'Playfair Display, serif' }}>Momentum Reflection: Carry It Forward</h3>
                            </div>
                            <div className="text-center  text-1xl text-gray-500 mb-5" >Every reflection opens a door. Based on your responses, here’s one question to carry with you:</div>
                            <div className="bg-white rounded-2xl shadow-md p-5 md:p-7">
                                <div className="text-center font-semibold text-gray-900" style={{ fontFamily: 'Playfair Display, serif', fontSize: '32px' }}>
                                    What’s one way you can honor your values more <br /> intentionally this week?
                                </div>
                            </div>
                        </div>

                        {/* <div className="rounded-lg border text-card-foreground shadow-sm bg-[#ffffff] p-6">
                            <h2 className="text-2xl font-bold text-gray-900 mb-2">Your Essence Echo Results</h2>

                            <p className="text-gray-600 mb-6">Summary of your reflections across values, passions, ambitions, fit, patterns, reactions, and impact.</p>

                            <div className="mb-6">
                                <div className="text-sm text-gray-600">Dominant Profile</div>
                                <div className="text-3xl font-extrabold mt-1">{dominantType || 'Balanced'}</div>
                            </div>

                            <div className="grid grid-cols-2 sm:grid-cols-4 gap-4">
                                <div className="rounded-md border p-4">
                                    <div className="text-xs text-gray-500 mb-1">D</div>
                                    <div className="text-xl font-semibold">{d?.percentage ?? 0}%</div>
                                </div>
                                <div className="rounded-md border p-4">
                                    <div className="text-xs text-gray-500 mb-1">I</div>
                                    <div className="text-xl font-semibold">{i?.percentage ?? 0}%</div>
                                </div>
                                <div className="rounded-md border p-4">
                                    <div className="text-xs text-gray-500 mb-1">S</div>
                                    <div className="text-xl font-semibold">{s?.percentage ?? 0}%</div>
                                </div>
                                <div className="rounded-md border p-4">
                                    <div className="text-xs text-gray-500 mb-1">C</div>
                                    <div className="text-xl font-semibold">{c?.percentage ?? 0}%</div>
                                </div>
                            </div>

                            <div className="mt-8 flex gap-4">
                                <button
                                    onClick={() => setShowReport(true)}
                                    className="px-6 py-2 rounded bg-purple-600 text-white hover:bg-purple-700"
                                >
                                    View Detailed Report
                                </button>
                                <button
                                    onClick={resetTest}
                                    className="px-6 py-2 rounded bg-purple-600 text-white hover:bg-purple-700"
                                >
                                    Retake Test
                                </button>
                            </div>
                        </div> */}

                        {/* Final CTA: Saved */}
                        <div className="mt-8 p-6 md:p-10 bg-[rgba(255,255,255,0.6)] shadow-[0px_2px_7px_rgba(0,0,0,0.07)] rounded-[24px]" style={{ width: "80%", margin: '50px auto' }}>
                            <div className="text-center">
                                <div
                                    className="mb-4 text-indigo-600"
                                    style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        gap: '12px',
                                        flexWrap: 'nowrap'
                                    }}
                                >
                                    <img
                                        src={medalstar}
                                        alt="save icon"
                                        style={{ width: '40px', height: '40px', objectFit: 'contain', display: 'inline-block' }}
                                    />
                                    <h3 className="text-4xl font-bold text-[#000]" style={{ fontFamily: 'Playfair Display, serif', margin: 0 }}>
                                        Your Essence Echo is safely saved
                                    </h3>
                                </div>
                                <div className="font-medium text-[18px] leading-[22px] text-center text-[#151417] mb-6" style={{ fontFamily: 'Lato, sans-serif' }}>This is only the beginning of your journey through The Hard Work Is The Hard Work Method.</div>
                                <div className="font-medium text-[18px] leading-[22px] text-center text-[#151417] mb-10" style={{ fontFamily: 'Lato, sans-serif' }}>In the coming weeks, you’ll unlock more steps, gain new insights, and see how your <br /> reflection evolves over time.</div>
                                <div className="flex items-center justify-center gap-3">
                                    {/* <button className="px-4 py-2 rounded-lg bg-white text-indigo-600 border border-indigo-200 hover:bg-indigo-50">
                                        Go to Dashboard
                                    </button> */}
                                    <button
                                        onClick={handleDownloadPDF}
                                        className="flex items-center justify-center px-4 py-2 h-[47px] rounded-lg bg-[#7A81FF] text-white hover:bg-indigo-700"
                                    >
                                        <p style={{position:'relative', top:'-10px'}}>Download My Reflection</p>
                                    </button>
                                </div>
                            </div>
                        </div>


                    </div>
                </div>
            </div>
        )
    }

    return (
        <div className="min-h-screen w-full overflow-x-hidden bg-gradient-to-br from-[#F7F8FA] via-white to-[#fcfaff] relative" style={{
            backgroundImage: `url(${esscoBg})`,
            backgroundColor: '#fcfaff',
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat'
        }}>
            {/* <Navbar /> */}
            <div className="fixed top-0 left-0 h-screen w-64 bg-white shadow-md z-10">
                <Sidebar />
            </div>
            <div className="ml-64 ">
                <Navbar toggleSidebar={() => { }} />

                {/* Main Content */}
                <div className="w-full max-w-7xl mx-auto pt-10 pb-8 px-4 sm:px-6 lg:px-8"
                >




                    <div

                        style={{ width: "100%" }}
                    >
                        <div className="p-8">
                            <div className="text-center mb-5">
                                <div className="flex items-center justify-center gap-3 mb-4">
                                    <img
                                        src={songicon}
                                        style={{
                                            width: '40px',
                                            height: '40px',
                                        }}
                                    />
                                    <h1 className=" font-semibold text-[36px] leading-[48px] text-[#000000]" style={{ fontFamily: 'Playfair Display, serif' }}>Essence Echo</h1>
                                </div>

                                <h2 className="text-center text-[18px] leading-[22px] font-extrabold text-[#7B82FF]" style={{ fontFamily: 'Playfair Display, serif' }}>{currentQuestion.question.split(' - ')[0]}</h2>
                                <p className="text-center text-[12px] leading-[14px] font-bold text-[#9E9FA0]">{currentQuestion.text.split(' - ')[0]}</p>

                            </div>

                            {currentQuestion.type === "wordbank" && (
                                <div className=" mt-6 rounded-lg border text-card-foreground shadow-sm mx-auto bg-[#ffffff99] p-6">
                                    <p className="text-[#000] font-semibold text-center mb-5" style={{ fontSize: 32, fontFamily: 'Playfair Display, serif' }}>{currentQuestion.question.split(' - ')[1]}</p>
                                    <p className='text-center text-[14px] leading-[17px] font-normal text-[#9E9FA0]'>Select up to 5 that feel most essential to who you are</p>
                                    <div style={{ width: "100%", margin: "0 auto" }}>
                                        <div className="flex justify-between items-center text-sm text-gray-600 mb-2">
                                            <span>
                                                Question {currentStep + 1} of {totalSteps}
                                            </span>
                                            <span>{Math.round(progress)}% Complete</span>
                                        </div>

                                        <div className="w-full h-1.5 bg-gray-200 rounded mb-6 overflow-hidden">
                                            <div className="h-full rounded-[10px] bg-[linear-gradient(90deg,_#ABB0FF_12.45%,_#7279EE_93.98%)] shadow-[0_2px_4px_rgba(0,0,0,0.05)] transition-all duration-300" style={{ width: `${progress}%` }}></div>
                                        </div>
                                    </div>
                                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3">
                                        {currentQuestion.wordbank.map((word) => {
                                            const isSelected = (selectedWords[currentStep] || []).includes(word)
                                            return (
                                                <button
                                                    key={word}
                                                    onClick={() => handleWordToggle(word)}
                                                    className={`px-4 py-3 rounded-lg text-sm font-medium transition-all duration-200 flex items-center gap-3 ${isSelected
                                                        ? " text-white rounded-[60px] border border-[#EBEBEB] bg-[linear-gradient(90.92deg,_#BE95D3_1.23%,_#FEB7B4_98.77%)]"
                                                        : "bg-gray-50 text-gray-700 hover:bg-gray-100 border border-gray-200 rounded-[60px]"
                                                        }`}
                                                >
                                                    <div className={`w-4 h-4 rounded-full border-2 flex items-center justify-center ${isSelected
                                                        ? "border-white bg-purple-300"
                                                        : "border-gray-300"
                                                        }`}>
                                                        {isSelected && (
                                                            <div className="w-2 h-2 bg-white rounded-full"></div>
                                                        )}
                                                    </div>
                                                    {word}
                                                </button>
                                            )
                                        })}
                                    </div>
                                </div>
                            )}
                            {currentQuestion.type === "text" && (
                                <div className=" mt-6 rounded-lg border text-card-foreground shadow-sm mx-auto bg-[#ffffff99] p-6">

                                    <p className="text-[#000] font-semibold text-center mb-5" style={{ fontSize: 32, fontFamily: 'Playfair Display, serif' }}>{currentQuestion.question.split(' - ')[1]}</p>
                                    <div style={{ width: "100%", margin: "0 auto" }}>
                                        <div className="flex justify-between items-center text-sm text-gray-600 mb-2">
                                            <span>
                                                Question {currentStep + 1} of {totalSteps}
                                            </span>
                                            <span>{Math.round(progress)}% Complete</span>
                                        </div>

                                        <div className="w-full h-1.5 bg-gray-200 rounded mb-6 overflow-hidden">
                                            <div className="h-full rounded-[10px] bg-[linear-gradient(90deg,_#ABB0FF_12.45%,_#7279EE_93.98%)] shadow-[0_2px_4px_rgba(0,0,0,0.05)] transition-all duration-300" style={{ width: `${progress}%` }}></div>
                                        </div>
                                    </div>
                                    <textarea
                                        value={textAnswers[currentStep] || ""}
                                        onChange={(e) =>
                                            setTextAnswers((prev) => ({
                                                ...prev,
                                                [currentStep]: e.target.value,
                                            }))
                                        }
                                        placeholder="Type your response here..."
                                        className="w-full border-2 border-gray-200 rounded-lg px-4 py-3 resize-none focus:outline-none focus:ring-2 focus:ring-purple-500 focus:border-purple-500 min-h-[150px] text-base bg-gray-50 focus:bg-white transition-all duration-200"
                                        rows={6}
                                    />
                                </div>
                            )}
                        </div>
                    </div>
                    {showEncouragement && (
                        <div className="fixed inset-0 z-50 flex items-center justify-center">
                            <div className="absolute inset-0 bg-white/70 backdrop-blur-sm"></div>
                            <div className="relative z-10 bg-white shadow-xl rounded-2xl px-8 py-6 text-center" >
                                <img src={plant} alt="save icon" className=" mb-4" style={{ margin: '0 auto', width: 120 }} />
                                <div className="font-semibold text-gray-800 mt-3" style={{ fontFamily: 'Playfair Display, serif', fontSize: '24px' }}>{encouragementText.split('\n').map((line, i) => (
                                    <span key={i}>{line}{i === encouragementText.split('\n').length - 1 ? '' : <br />}</span>
                                ))}</div>
                            </div>
                        </div>
                    )}
                    <div className="flex justify-between items-center gap-4 mt-8 mx-auto" style={{ width: "85%" }}>


                        <button
                            onClick={() => setCurrentStep((prev) => Math.max(prev - 1, 0))}
                            disabled={currentStep === 0}
                            className="px-6 py-3 rounded-lg border-2 border-purple-200 text-purple-600 bg-white 
                     hover:bg-purple-50 hover:border-purple-300 disabled:opacity-50 disabled:cursor-not-allowed transition-all duration-200 font-medium"
                        >
                            Previous
                        </button>
                        <div className="flex gap-4">
                            <button
                                onClick={handleNext}
                                disabled={
                                    (currentQuestion.type === "wordbank" && (selectedWords[currentStep] || []).length === 0) ||
                                    (currentQuestion.type === "text" && !(textAnswers[currentStep] || "").trim()) ||
                                    saving
                                }
                                className="px-8 py-3 rounded-lg bg-[#7A81FF] text-white hover:bg-[#7A81FF] 
                     disabled:opacity-50 disabled:cursor-not-allowed transition-all duration-200 font-medium shadow-lg hover:shadow-xl"
                            >
                                {saving ? "Processing..." : currentStep === totalSteps - 1 ? "Finish" : "Next Question"}
                            </button>
                        </div>
                    </div>


                </div>
            </div>
            {/* <div style={{ height: '2px', width: '100%', background: ' linear-gradient(90deg, #ff5e62 0%, #ff9966 30%, #f9d423 50%, #a1c4fd 70%, #2b86c5 100%)' }} /> */}

            {/* <Footer /> */}
        </div>
    );
};

export default SevenQuestion; 